/** 色を選んでいない人の既定色。予定表の teal/plum と同じ */
export const DEFAULT_SELF_COLOR = "#2f6b66";
export const DEFAULT_PARTNER_COLOR = "#8c5a76";

const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;

export function isValidHexColor(value: string): boolean {
  return HEX_COLOR_RE.test(value);
}

function hexToRgb(hex: string): [number, number, number] {
  const n = Number.parseInt(hex.slice(1), 16);
  return [(n >> 16) & 0xff, (n >> 8) & 0xff, n & 0xff];
}

function rgbToHex(r: number, g: number, b: number): string {
  return `#${[r, g, b].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
}

/** 2人ぶんの色を混ぜる。「2人の予定」の色に使う */
export function mixHexColors(a: string, b: string): string {
  const [r1, g1, b1] = hexToRgb(a);
  const [r2, g2, b2] = hexToRgb(b);
  return rgbToHex(Math.round((r1 + r2) / 2), Math.round((g1 + g2) / 2), Math.round((b1 + b2) / 2));
}

/** 背景に敷いたときに読みやすいほうの文字色(黒系 or 白)を選ぶ */
export function contrastTextColor(hex: string): string {
  const [r, g, b] = hexToRgb(hex);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 150 ? "#262421" : "#ffffff";
}

/** バッジなど薄い背景用に、指定した色へアルファ(2桁の16進)を足す */
export function withAlpha(hex: string, alphaHex: string): string {
  return `${hex}${alphaHex}`;
}

/**
 * ある人を表す色。プロフィールで選んだ「好きな色」があればそれ、
 * 無ければ自分/相手の既定色にフォールバックする(→ lib/profileItems.ts の favoriteColor)。
 */
export function colorOfUser(
  profiles: readonly { id: string; favoriteColor: string | null }[] | undefined,
  userId: string,
  selfId: string | undefined,
): string {
  const favoriteColor = profiles?.find((profile) => profile.id === userId)?.favoriteColor;
  if (favoriteColor !== null && favoriteColor !== undefined) return favoriteColor;
  return userId === selfId ? DEFAULT_SELF_COLOR : DEFAULT_PARTNER_COLOR;
}
